import { lazy } from 'react';
// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import ActivityLog from 'views/pages/activityLog';
import { MODULE } from 'constants';
import SignInCard from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/EmailIntegration.js/SignInCard';
import EmailIntegration from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/EmailIntegration.js';
import WebForm from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/WebForm';
import UpdateProfile from 'views/pages/dashboard/CompanyProfile/UpdateCompnayDetails';
import IntegrateDiolog from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog';
import QuestionRegistryExtension from 'views/pages/dashboard/ResponseTemplates/QuestionRegistryExtension';
import PermisssionViewValidationWrapper from 'Components/PermissionWrapper/PermissionViewValidationWrapper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';
const AuthGuard = Loadable(lazy(() => import('Components/AuthGuard')));
const DashboardDefault2 = Loadable(lazy(() => import('views/dashboard/Default')));
const DashboardDefault = Loadable(lazy(() => import('views/pages/dashboard/')));
const FAQ = Loadable(lazy(() => import('views/pages/dashboard/FAQ')));
const Profile = Loadable(lazy(() => import('views/pages/dashboard/Profile')));
const CompanyProfile = Loadable(lazy(() => import('views/pages/dashboard/CompanyProfile')));
const ExecutiveTeamMember = Loadable(lazy(() => import('views/pages/dashboard/CompanyProfile/ExecutiveTeamMember')));
const ContactUs = Loadable(lazy(() => import('views/pages/dashboard/ContactUs')));
// const Questions = Loadable(lazy(() => import('views/pages/dashboard/Questions')));
const Announcements = Loadable(lazy(() => import('views/pages/dashboard/Announcements')));
const ResponseTemplates = Loadable(lazy(() => import('views/pages/dashboard/ResponseTemplates')));
const KanbanQuestionBoard = Loadable(lazy(() => import('views/pages/dashboard/KanbanQuestions')));
const History = Loadable(lazy(() => import('views/pages/dashboard/History')));
const MyTeam = Loadable(lazy(() => import('views/pages/dashboard/MyTeam')));
const AccountDetailSidebar = Loadable(lazy(() => import('views/pages/dashboard/MyTeam/AccountDetailSidebar')));
const Calendar = Loadable(lazy(() => import('views/pages/dashboard/Calendar')));
const Notifications = Loadable(lazy(() => import('views/pages/dashboard/Notifications')));

const DashboardRoutes = {
    path: '/dashboard',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: (
                <ActivityLog module={MODULE.dashboard}>
                    <DashboardDefault />
                </ActivityLog>
            )
        },
        {
            path: '/history-of-activity',
            element: (
                <ActivityLog module={MODULE.history}>
                    <History />
                </ActivityLog>
            )
        },
        {
            path: '/questions',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.questionBoard}>
                    <ActivityLog module={MODULE.question}>
                        <KanbanQuestionBoard />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: '/dashboard2',
            element: (
                <ActivityLog module={MODULE.dashboard2}>
                    <DashboardDefault2 />
                </ActivityLog>
            )
        },
        {
            path: '/faq',
            element: (
                <ActivityLog module={MODULE.faq}>
                    <FAQ />
                </ActivityLog>
            )
        },
        {
            path: '/profile',
            element: (
                <ActivityLog module={MODULE.profile}>
                    <Profile />
                </ActivityLog>
            )
        },
        {
            path: '/contact-us',
            element: (
                <ActivityLog module={MODULE.contact}>
                    <ContactUs />
                </ActivityLog>
            )
        },
        {
            path: '/announcements',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.announcements}>
                    <ActivityLog module={MODULE.announcement}>
                        <Announcements />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: '/announcements/:token',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.announcements}>
                    <ActivityLog module={MODULE.announcement}>
                        <Announcements />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: '/company-profile',
            element: (
                <ActivityLog module={MODULE.companyProfile}>
                    <CompanyProfile />
                </ActivityLog>
            ),
            children: [
                {
                    path: 'company-details',
                    element: (
                        <PermisssionViewValidationWrapper
                            showPermissionInfo={true}
                            pageName={PermissionTypes.companyDetails}
                            isNotNavigate={true}
                        >
                            {' '}
                            <UpdateProfile />{' '}
                        </PermisssionViewValidationWrapper>
                    )
                },
                {
                    path: 'excutive-team',
                    element: (
                        <PermisssionViewValidationWrapper
                            showPermissionInfo={true}
                            pageName={PermissionTypes.executiveTeam}
                            isNotNavigate={true}
                        >
                            <ExecutiveTeamMember />{' '}
                        </PermisssionViewValidationWrapper>
                    )
                },
                {
                    path: 'integrate-diolog',
                    element: (
                        <PermisssionViewValidationWrapper pageName={PermissionTypes.diologIntegration}>
                            {' '}
                            <IntegrateDiolog />{' '}
                        </PermisssionViewValidationWrapper>
                    ),
                    children: [
                        {
                            path: '/email-extension',
                            element: (
                                <PermisssionViewValidationWrapper pageName={PermissionTypes.emailExtension}>
                                    <ActivityLog module={MODULE.SignInIntegration}>
                                        <EmailIntegration />
                                    </ActivityLog>
                                </PermisssionViewValidationWrapper>
                            )
                        },
                        {
                            path: '/web-form',
                            element: (
                                <PermisssionViewValidationWrapper pageName={PermissionTypes.webform}>
                                    <ActivityLog module={MODULE.Webform}>
                                        <WebForm />
                                    </ActivityLog>
                                </PermisssionViewValidationWrapper>
                            )
                        }
                    ]
                }
            ]
        },
        {
            path: '/executive-team',
            elecments: (
                <ActivityLog module={MODULE.executive}>
                    <ExecutiveTeamMember />
                </ActivityLog>
            )
        },
        {
            path: '/my-team',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.myTeam}>
                    <ActivityLog module={MODULE.myTeam}>
                        <MyTeam />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: '/my-team-details',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.myTeam}>
                    <ActivityLog module={MODULE.myTeamDetai}>
                        <AccountDetailSidebar />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: 'question-registry',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.questionRegistries}>
                    <ActivityLog module={MODULE.questionRegistry}>
                        <ResponseTemplates />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: 'calendar',
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.calendar}>
                    <ActivityLog module={MODULE.calendar}>
                        <Calendar />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: 'notifications',
            element: (
                <ActivityLog module={MODULE.notification}>
                    <Notifications />
                </ActivityLog>
            )
        },
        {
            path: 'question-registry-email/:id', // changing this will effect Sidebar.js and EditTemplate.js
            element: (
                <PermisssionViewValidationWrapper pageName={PermissionTypes.emailExtension}>
                    <ActivityLog module={MODULE.QuestionRegistryExtension}>
                        <QuestionRegistryExtension />
                    </ActivityLog>
                </PermisssionViewValidationWrapper>
            )
        },
        {
            path: '/*',
            element: <DashboardDefault />
        }
    ]
};

export default DashboardRoutes;
